import Vue from "vue";

var Bus = (window.Bus = new Vue());

export default Bus;
